<template>
  <ValidationObserver ref="obs" v-slot="{ invalid, handleSubmit }">
    <v-card class="elevation-0">
      <v-card-title class="pt-0">
        {{ $t('create_account') }}
      </v-card-title>

      <alert :config="alertConfig"></alert>

      <v-stepper value="1" class="elevation-0 ma-0 pa-0" ma-0 pa-0>
        <v-stepper-header>
          <v-stepper-step step="1">{{
            $t('select_your_country')
          }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4"></v-stepper-step>
        </v-stepper-header>
      </v-stepper>

      <v-card-text>
        <p class="text-body-1">
          {{ $t('app_availability_msg') }}
        </p>

        <VSelectWithValidation
          name="country"
          rules="required"
          v-model="country"
          :items="availableCountries"
          :label="$t('select_a_country')"
          outlined
          item-value="country_code"
        >
          <template v-slot:selection="data">
            <v-select-item :data="data"></v-select-item>
          </template>
          <template v-slot:item="data">
            <v-select-item :data="data"></v-select-item>
          </template>
        </VSelectWithValidation>
      </v-card-text>
      <v-card-actions>
        <v-btn color="indigo lighten-5" @click="cancel">{{
          $t('cancel_registration')
        }}</v-btn>
        <v-spacer></v-spacer>
        <submit-button
          color="secondary"
          :loading="submitButtonLoading"
          @click="handleSubmit(next)"
          :disabled="invalid || submitButtonLoading"
          >{{ $t('next') }}
        </submit-button>
      </v-card-actions>
      <v-card-actions>
        <span>
          {{ $t('have_account') }}
          <a v-on:click="signIn">{{ $t('sign_in') }}</a>
        </span>
      </v-card-actions>
      <v-card-actions>
        <span>
          {{ $t('forgot_password') }}
          <a v-on:click="forgot">{{ $t('reset_password') }}</a>
        </span>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>

<script>
import availableCountries from '@/assets/data/available-countries';
import { formMixin } from '../../mixins/formMixin';

const VSelectItem = {
  props: {
    data: {
      type: Object
    }
  },
  render(h) {
    return h('div', { class: 'd-flex align-center' }, [
      h('img', {
        attrs: {
          class: 'mr-3',
          width: 24,
          src: require(`../../assets/img/_${this.data.item.country_code}/${this.data.item.country_code}.svg`) // this is now a module request
        }
      }),
      h('span', { class: 'text-uppercase' }, this.data.item.country_name)
    ]);
  }
};

export default {
  name: 'select-country',
  mixins: [formMixin],
  components: {
    VSelectItem
  },
  data() {
    return {
      availableCountries,
      countrySelected: null
    };
  },
  methods: {
    cancel() {
      this.$router.push({ path: '/home' });
    },
    next() {
      this.$router.push({ path: '/account-type' });
    },
    signIn() {
      this.$router.push({ path: '/sign-in' });
    },
    forgot() {
      this.$router.push({ path: '/forgot-password' });
    }
  },
  computed: {
    country: {
      get() {
        return this.$store.getters['auth/country'];
      },
      set(value) {
        this.$store.dispatch('auth/setCountry', value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/stepper';
</style>
